(function () {
	"use strict";

	/*global angular*/
	var app = angular.module('cccu.photoUpload.instructions', ['ui.router']);

	app.config(function ($stateProvider) {
		$stateProvider.state('instructions', {
			url: '/instructions',
			views: {
				"main": {
					controller: 'InstructionsController',
					templateUrl: 'instructions/index.html'
				}
			},
			data: {
				pageTitle: 'Upload your photo'
			}
		});
	});

	app.controller('InstructionsController', ['$scope', '$location', '$log', '$modal', function ($scope, $location, $log, $modal) {
		$scope.showExamples = function () {
			$location.path('/examples');
		};

		$scope.next = function () {
			$location.path('/upload');
		};

		$scope.back = function () {
		    $location.path('/');
		};

		$scope.showExamples = function () {
		    var modalInstance = $modal.open({
		        templateUrl: 'common/modalRender.html',
		        controller: ['$scope', '$modalInstance', function ($scope, $modalInstance) {
		            $scope.modalHeader = 'Good and Bad photo Examples';
		            $scope.modalContent = 'instructions/examples.html';
		            $scope.ok = function () {
		                $modalInstance.close();
		            };
		        }]
		    });
		}
        
	}]);
}());